const variables = {}
const $ = jQuery.noConflict()

export { $, variables }
